import { useTranslation } from "react-i18next";
import LinkButton from "../components/LinkButton";

const BROKERS = ["freedom", "interactive"];

function BrokerCard({ broker }) {
  const { t } = useTranslation();
  const name = t(`reportInstructions.brokers.${broker}.name`);
  const steps = t(`reportInstructions.brokers.${broker}.steps`, { returnObjects: true });
  const headingId = `report-instructions-${broker}`;

  return (
    <section aria-labelledby={headingId} className="rounded-2xl bg-white border border-[#e2e2e2] p-5">
      <h2 id={headingId} className="text-sm font-semibold mb-4">
        {name}
      </h2>
      <ol className="list-decimal pl-5 space-y-2 text-sm text-[#14171a]">
        {steps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ol>
    </section>
  );
}

function ReportInstructionsPage() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <LinkButton to="/unified-upload" className="mb-5">
        <span aria-hidden="true">←</span>
        {t("reportInstructions.back")}
      </LinkButton>
      <h1 className="text-2xl font-semibold tracking-tight">{t("reportInstructions.title")}</h1>
      <p className="text-sm mt-2 max-w-[560px] text-[#8c8c8c]">{t("reportInstructions.subtitle")}</p>
      <div className="grid md:grid-cols-2 gap-5 mt-7">
        {BROKERS.map((broker) => (
          <BrokerCard key={broker} broker={broker} />
        ))}
      </div>
      <p className="text-xs mt-6 text-[#8c8c8c]">{t("reportInstructions.notFound")}</p>
    </div>
  );
}

export default ReportInstructionsPage;
